webpackJsonp([2],{

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
module.exports = __webpack_require__(858);


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(169);

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = __webpack_require__(55);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataTables;

$.ajaxSetup({
    beforeSend: function beforeSend(xhr, settings) {
        if (!settings.crossDomain && window.currentCspNonce) {
            xhr.setRequestHeader("x-dcs-csp-nonce", window.currentCspNonce);
        }
    }
});

$('[data-submit-form]').click(function () {
    var targetId = $(this).data('submit-form');
    var $target = $('#' + targetId);
    if ($target.length < 1) {
        Sentry.captureMessage("Failed to find data-submit-form=" + targetId);
    }
    if ($target.length > 1) {
        Sentry.captureMessage("Expected to find exactly one data-submit-form=" + targetId);
    }
    $target.submit();
});

$(document).on('click', '[data-click-button]', function () {
    var targetId = $(this).data('click-button');
    var scrollIntoView = $(this).data('scroll-into-view') !== undefined;
    var $target = $('#' + targetId);
    if ($target.length < 1) {
        Sentry.captureMessage("Failed to find data-click-button=" + targetId);
    }
    if ($target.length > 1) {
        Sentry.captureMessage("Expected to find exactly one data-click-button=" + targetId);
    }
    $target.click();
    if (scrollIntoView) $target[0].scrollIntoView();
});

$(document).on('click', '[data-copy-to-clipboard-button]', function () {
    var targetId = $(this).data('copy-to-clipboard-button');
    var $target = $('#' + targetId);
    $target.select();
    document.execCommand("copy");
});

$(document).on('change', '[data-submit-on-change]', function () {
    $(this).parents('form').submit();
});

$(document).on('change', '.js-select-link', function () {
    window.location = this.value;
});

$(document).on('click', '.js-link', function () {
    var href = $(this).data('href');
    if (href) window.location = href;
});

$(document).on('change', '.js-smart-admin-file-widget input', function () {
    this.parentNode.nextSibling.value = this.value;
});

$('[data-show-when-checked]').each(function () {
    var $elem = $(this),
        $target = $('#' + $elem.data('show-when-checked'));
    $target.change(function (e) {
        $elem.toggleClass('hidden', !e.target.checked);
    });
    $elem.toggleClass('hidden', !$target[0].checked);
});

function runActivatorsIn(topElement) {
    var $container = $(topElement);

    $container.find('[data-hide-when-checked]').each(function () {
        var $elem = $(this),
            target_selector = '#' + $elem.data('hide-when-checked'),
            $target = $(target_selector);
        if (!$elem.data('hide-when-checked-initialized')) {
            $elem.data('hide-when-checked-initialized', true);

            $target.change(function (e) {
                $elem.toggleClass('hidden', e.target.checked);
            });
            if ($target.length > 0) {
                $elem.toggleClass('hidden', $target[0].checked);
            } else {
                Sentry.captureMessage('data-hide-when-checked: Failed to find ' + target_selector);
                console.error('data-hide-when-checked: Failed to find ' + target_selector, { $elem: $elem });
            }
        }
    });
}
runActivatorsIn(document);

$(document).on('loaded.bs.modal', function (e) {
    runActivatorsIn(e.target);
});

// modal-open dla zagnieżdżonych modali {
var bsModalCount = 0;
$(document).on('show.bs.modal', function (event) {
    if (!event.target.dataset.dontCountAsModal) bsModalCount += 1;
    $('body').toggleClass('modal-open', bsModalCount > 0);
});
$(document).on('hidden.bs.modal', function (event) {
    if (!event.target.dataset.dontCountAsModal) bsModalCount -= 1;
    $('body').toggleClass('modal-open', bsModalCount > 0);
});
// }

$(document).on('hide.bs.modal', function () {
    $(this).find('.js-needs-destroy').trigger('weekly:deactivate-elem');
});
$(document).on('hidden.bs.modal', function () {
    $(this).find('.js-needs-destroy').trigger('weekly:destroy-elem');
});

$(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function () {
    // Czyszczenie modala ładowanego z URLa.
    if ($(this).is('a[href]')) {
        var target = $(this).data('target');
        var $target = $(target);
        $target.on('hidden.bs.modal', function () {
            var content = $target.find('.modal-content');
            content.html('');
        });
    }
});

$('.modal:not(.question-modal)').on('show.bs.modal', function () {
    // $(this).appendTo($('body'));
});

$('.modal').on('shown.bs.modal', function () {
    $(this).find('[autofocus]').focus();
});

$(document).on('submit', '.ajax-form', function (e) {
    var form = $(this);
    var disableOnSubmit = form.data('disable-on-submit');
    var extraData = {};
    var elementsToEnableAfterSubmit = $();
    var elementsToRemoveAfterSubmit = $();
    if (e.isDefaultPrevented()) return;
    if (e.originalEvent && e.originalEvent.submitter) {
        // submitter to kliknięty przycisk
        if (e.originalEvent.submitter.name && e.originalEvent.submitter.value) {
            extraData[e.originalEvent.submitter.name] = e.originalEvent.submitter.value;
        }
    }

    if (disableOnSubmit) {
        elementsToEnableAfterSubmit = form.find('button:not(:disabled)');
        elementsToEnableAfterSubmit.attr('disabled', true);
        elementsToRemoveAfterSubmit = $('<div class="spinner-overlay"><i class="fa fa-cog fa-4x spinner-overlay__spinner" aria-hidden="true"><span class="sr-only">Processing, please wait</span></i></div>').appendTo(form);
    }

    var options = {
        data: extraData,
        complete: function complete() {
            elementsToEnableAfterSubmit.attr('disabled', false);
            elementsToRemoveAfterSubmit.remove();
        },
        error: function error(response) {
            if (response.status === 403 || response.status === 400) {
                var event = $.Event('ajaxForm:error', {});
                form.trigger(event);
                var replace = form.data('ajax-form-replace') || '.modal-base';
                var $replace = form.closest(replace);
                if ($replace.length === 0) console.error("Couldn't find ajax-form-replace target", replace);
                $replace.replaceWith(response.responseJSON.content);
            }
        },
        success: function success(data) {
            var event = $.Event('ajaxForm:submitted', { responseData: data });
            form.trigger(event);
            if (event.isDefaultPrevented()) return;

            if (data.action === 'refresh') {
                window.location.reload();
            }
            if (data.action === 'redirect') {
                var redirectContainer = $('.ajax-form-redirect-container').last();
                if (redirectContainer.length > 0) {
                    redirectContainer.load(data.url);
                    return;
                }
                var url_elements = data.url.split("#");
                if (url_elements.length === 1 || window.location.pathname !== url_elements[0]) {
                    window.location.assign(data.url);
                } else {
                    // append hash and reload
                    window.location.hash = url_elements[1];
                    window.location.reload();
                }
            }
        }
    };
    form.ajaxSubmit(options);
    return false;
});

$(document).on('click', '.js-delete', function (event) {
    var $button = $(this);
    var deleteUrl = $button.data('deleteUrl');
    var deleteMessage = $button.data('deleteMessage');
    var removeParent = $button.data('removeParent');
    var removeElements = $button.data('removeElements');
    var hideElements = $button.data('hideElements');
    var refreshOnSuccess = $button.data('refreshOnSuccess');
    var disableTheButton = !$button.attr("disabled");

    event.preventDefault();

    $.SmartMessageBox({
        'title': deleteMessage,
        'buttons': '[' + gettext('No') + '][' + gettext('Yes') + ']'
    }, function (button) {
        if (button === gettext('Yes')) {
            if (disableTheButton) $button.attr('disabled', true);

            $.post(deleteUrl, function () {
                if (removeParent) $button.parents(removeParent).remove();
                if (removeElements) $(removeElements).remove();
                if (hideElements) $(hideElements).hide();
                if (refreshOnSuccess) window.location.reload();
            }).always(function () {
                if (disableTheButton) $button.attr('disabled', false);
            });
        }
        return true;
    });
});

var responsiveHelper_dt_basic = undefined;

var breakpointDefinition = {
    tablet: 1024,
    phone: 480
};

jQuery.fn.dataTableExt.oSort['status-asc'] = function (x, y) {
    return x < y ? -1 : x > y ? 1 : 0;
};

jQuery.fn.dataTableExt.oSort['status-desc'] = function (x, y) {
    return x < y ? 1 : x > y ? -1 : 0;
};

datatablesLangPl['sLengthMenu'] = '_MENU_&nbsp;';

var baseDataTableSettings = {
    "sDom": "t" + "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'<p><l><r>>>",
    "autoWidth": false,
    "preDrawCallback": function preDrawCallback() {
        // Initialize the responsive datatables helper once.
        if (!responsiveHelper_dt_basic) {
            responsiveHelper_dt_basic = new ResponsiveDatatablesHelper($('.dataTable'), breakpointDefinition);
        }
    },
    "rowCallback": function rowCallback(nRow) {
        responsiveHelper_dt_basic.createExpandIcon(nRow);
    },
    "drawCallback": function drawCallback(oSettings) {
        responsiveHelper_dt_basic.respond();
        $(".dataTable .easy-pie-chart").each(function () {
            var a = $(this),
                b = a.css("color") || a.data("pie-color"),
                c = a.data("pie-track-color") || "rgba(0,0,0,0.04)",
                d = parseInt(a.data("pie-size")) || 25;
            a.easyPieChart({
                "barColor": b,
                "trackColor": c,
                "scaleColor": !1,
                "lineCap": "butt",
                "lineWidth": parseInt(d / 8.5),
                "animate": 1500,
                "rotate": -90,
                "size": d,
                "onStep": function onStep(a, b, c) {
                    $(this.el).find(".percent").text(Math.round(c));
                }
            }), a = null;
        });
    },
    language: datatablesLang,
    order: [],
    aoColumnDefs: [{ "sType": "status", "aTargets": ["status"] }, { "bSortable": false, "aTargets": ['nosort'] }]
};

var dataTableSettings = $.extend({}, baseDataTableSettings);
var noSearchDataTableSettings = $.extend({}, baseDataTableSettings, {
    searching: false
});
var ajaxDataTableSettings = $.extend({}, baseDataTableSettings, {
    'serverSide': true,
    'ajax': function ajax(data, callback, settings) {
        var instance = settings.oInstance;
        var url = instance.data('url');
        $.get(url, data, callback);
    }
});

var Debouncer = function Debouncer(time) {
    this._time = time;
    this._timeoutId = undefined;
};
Debouncer.prototype.run = function (fun) {
    clearTimeout(this._timeoutId);
    this._timeoutId = setTimeout(fun, this._time);
};

var dtRenderText = function dtRenderText(data) {
    if (typeof data === "string") {
        return data.replace(/</g, "&lt;");
    }
    return data;
};

// Mamy starą wersję DataTables, nie ma jeszcze eventu na błędy.
$.fn.DataTable.ext.errMode = "alert";
function _custom_alert(message) {
    if (message && typeof message === "string" && message.startsWith("DataTables")) {
        Sentry.captureMessage('DataTables alert: ' + message);
    }
    _custom_alert.__original__.apply(this, arguments);
}
_custom_alert.__original__ = window.alert;
window.alert = _custom_alert;

$('.dataTable').each(function () {
    var paging = this.dataset.paging !== "false";
    $(this).DataTable((0, _assign2.default)({}, dataTableSettings, {
        "bPaginate": paging
    }));
}).each(function () {
    enableDataTableFilters($(this), { debounce: 100 });
});

$('.noSearchDataTable').each(function () {
    var $this = $(this);
    var options = {};
    $.extend(options, noSearchDataTableSettings, $this.data());
    if (options.paging === false)
        // Drop the whole footer
        options.sDom = options.sDom.replace(/<'dt-toolbar-footer'.*/, '');
    $this.DataTable(options);
});

window.initializeAjaxDataTable = function initializeAjaxDataTable($table) {
    var settings = $.extend({}, ajaxDataTableSettings);
    var columns = [],
        order = [];
    $table.find('.header th').each(function () {
        var column = {
            'data': $(this).data('column'),
            'className': $(this).data('class-name')
        };
        if (!$(this).data('html-safe')) {
            column.render = dtRenderText;
        }
        if ($(this).data('default-order')) {
            order.push([columns.length, $(this).data('default-order')]);
        }
        columns.push(column);
    });
    var language = $table.data('language');
    if ((typeof language === 'undefined' ? 'undefined' : (0, _typeof3.default)(language)) === 'object') {
        settings.language = $.extend({}, settings.language, language);
    }
    settings.columns = columns;
    settings.order = order;
    $table.DataTable(settings);
    enableDataTableFilters($table, { debounce: 250 });
};

function enableDataTableFilters($table, options) {
    // Filters support
    var filterDebouncer = new Debouncer(options.debounce);

    $("thead .hasinput input[type=text], thead .hasinput select", $table).on('keyup change', function () {
        var $input = $(this),
            dt = $input.parents('table').DataTable(),
            $column = $(this).parents('.hasinput'),
            columnIndex = $column.prevAll().toArray().reduce(function (acc, e) {
            return acc + (e.colSpan || 1);
        }, 0);
        if (!$input.val()) $input.addClass('empty');else $input.removeClass('empty');
        filterDebouncer.run(function () {
            dt.column(columnIndex + ':visible').search($input.val()).draw();
        });
    });
}

$('.ajax-dataTable').each(function () {
    initializeAjaxDataTable($(this));
});

function initializeCharacterCounter(elem) {
    var $container = $(elem);
    var $input = $('#' + $container.data('counterFor'));
    var maxLength = $input.attr('maxlength');
    if (!maxLength) {
        console.warn("initializeCharacterCounter: brak maxlength na ", $container.data('counterFor'), $input);
        return;
    }
    $input.attr('maxlength', null);

    var eventHasChar = function eventHasChar(e) {
        if (typeof e.char != 'undefined') return e.char.length > 0;
        if (e.ctrlKey) return false;
        return e.charCode != 0 || e.keyCode == 13;
    };

    var lockMax = function lockMax(e) {
        var newCharsLen;
        if (e.type == "paste") {
            var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
            var pasted = clipboardData.getData('Text');
            newCharsLen = pasted.length;
        } else if (e.type == "keypress" && eventHasChar(e)) {
            newCharsLen = 1;
        } else {
            return true;
        }
        if (e.target.value.length + newCharsLen > maxLength) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
    };
    var updateCounter = function updateCounter() {
        setTimeout(function () {
            $container.html($input.val().length + ' / ' + maxLength);
        }, 1);
    };
    $input.on('keypress paste', lockMax);
    $input.on('keydown paste', updateCounter);
    updateCounter();
}
$('.character-counter').each(function () {
    initializeCharacterCounter(this);
});

window.initializeCharacterCounter = initializeCharacterCounter;

$(document).on('click', '.custom-jarviswidget-toggle-btn', function (e) {
    var content = $(this).closest('.jarviswidget').find('[role=content]');
    if (content.is(':visible')) {
        content.slideUp(200);
        $(this).find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
    } else {
        content.slideDown(200);
        $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
    }
    e.preventDefault();
});

$(document).on('click', '.custom-jarviswidget-edit-btn', function (e) {
    var content = $(this).closest('.jarviswidget').find('[role=help]');
    if (content.is(':visible')) {
        content.slideUp(200);
    } else {
        content.slideDown(200);
    }
    e.preventDefault();
});

var widgets = '.jarviswidget',
    fullscreenClass = ['fullscreen-10', 'normalscreen-10'],
    pwCtrls = '.jarviswidget-ctrls';

function heightFullscreen() {
    if ($('#jarviswidget-fullscreen-mode').length) {
        var heightWindow = $(window).height();
        var heightHeader = $('#jarviswidget-fullscreen-mode').children(widgets).children('header').height();

        $('#jarviswidget-fullscreen-mode').children(widgets).children('div').height(heightWindow - heightHeader - 15);
    }
}

$(document).on('click', '.jarviswidget-fullscreen-btn', function (e) {
    var thisWidget = $(this).parents(widgets);
    var thisWidgetContent = thisWidget.children('div');
    if ($('#jarviswidget-fullscreen-mode').length) {

        $('.nooverflow').removeClass('nooverflow');

        thisWidget.unwrap('div').children('div').removeAttr('style').end().find('.jarviswidget-fullscreen-btn:first').children().removeClass(fullscreenClass[1]).addClass(fullscreenClass[0]).parents(pwCtrls).children('a').show();

        if (thisWidgetContent.hasClass('jarviswidget-visible')) {
            thisWidgetContent.hide().removeClass('jarviswidget-visible');
        }
    } else {

        $('body').addClass('nooverflow');

        thisWidget.wrap('<div id="jarviswidget-fullscreen-mode"/>').parent().find('.jarviswidget-fullscreen-btn:first').children().removeClass(fullscreenClass[0]).addClass(fullscreenClass[1]).parents(pwCtrls).children('a:not(.jarviswidget-fullscreen-btn)').hide();

        if (thisWidgetContent.is(':hidden')) {
            thisWidgetContent.show().addClass('jarviswidget-visible');
        }
    }

    heightFullscreen();
    e.preventDefault();
});

$(document).on('click', '.js-create-folder', function (e) {
    if (e.defaultPrevented) return;
    var $target = $(e.currentTarget);
    $.createFolder({
        parent: $target.data('parent'),
        createFolderUrl: $target.data('createFolderUrl'),
        context: $target.data('context')
    }, function (data) {
        window.location.href = data.folderUrl;
    });
});

$(document).on('click', '.js-edit-folder', function (e) {
    if (e.defaultPrevented) return;
    var $target = $(e.currentTarget);
    $.editFolder({
        name: $target.data('name'),
        updateUrl: $target.data('updateUrl'),
        context: $target.data('context')
    }, function (data) {
        window.location.href = data.folderUrl;
    });
});

$(document).on('click', '.js-remove-folder', function (e) {
    if (e.defaultPrevented) return;
    var $button = $(e.currentTarget);
    var deleteUrl = $button.data('remove-folder-url');

    $.SmartMessageBox({
        'title': gettext('Do you really want to delete this folder?'),
        'buttons': '[' + gettext('No') + '][' + gettext('Yes') + ']'
    }, function (button) {
        if (button === gettext('Yes')) {
            $.post(deleteUrl, function (data) {
                window.location.href = data.url;
            });
        }
        return true;
    });
});

window.openSmartMessageBoxConfirmation = function openSmartMessageBoxConfirmation(title, yesCallback) {
    $.SmartMessageBox({
        'title': title,
        'buttons': '[' + escapeButtonName(gettext('No')) + '][' + escapeButtonName(gettext('Yes')) + ']'
    }, function (button) {
        if (button === gettext('Yes')) {
            yesCallback();
        }
        return true;
    });
};

window.initializeColorPickers = function initializeColorPickers($form) {
    $($form || 'body').find('.colorpicker-component').each(function () {
        initializeColorPickerByElem($(this));
    });
};

window.initializeColorPickerByElem = function initializeColorPickerByElem($pickerComponent) {
    var $picker = $pickerComponent.find("input").first();
    $picker.colorpicker();
    $picker.on('changeColor', updatePicker);
    $picker.on('hide', function (event) {
        $picker.trigger('change', event);
    });
    $picker.on('blur', function () {
        $picker.colorpicker("hide");
    });
    updatePicker();

    function updatePicker() {
        var value = $picker.data('colorpicker').color.toHex();
        $picker.siblings('.input-group-addon').find('i').css({ backgroundColor: value });
        $picker.val(value);
    }
};

$(window).on('resize', function () {
    heightFullscreen();
});

/***
 * Prosty system reagowania na zmiany.
 * Uruchamia connect, potem update(), i po każdym wywołaniu handler() znów uruchamia update()
 *
 * @template State
 * @param {(handler: () => undefined) => State} connect Funkcja rejestrująca uchwyty
 * @param {(state: State, updateState: ((newState: State) => undefined)) => undefined} update Funkcja wczytująca stan i aktualizująca DOM
 */
window.watcher = function watcher(connect, update) {
    var watcher = {
        state: null,
        reconnect: function reconnect() {
            var handleChange = watcher.render;
            watcher.state = connect(handleChange);
            watcher.render();
        },
        update: function updateWatcher(newState) {
            if ((0, _typeof3.default)(watcher.state) === 'object' && (typeof newState === 'undefined' ? 'undefined' : (0, _typeof3.default)(newState)) === 'object') {
                watcher.state = (0, _assign2.default)({}, watcher.state, newState);
            } else {
                watcher.state = newState;
            }
        },
        render: function renderWatcher() {
            update(watcher.state, watcher.update);
        }
    };
    watcher.reconnect();
    return watcher;
};

window.escapeButtonName = function escapeButtonName(raw) {
    return raw.replaceAll('[', '&lsqb;').replaceAll(']', '&rsqb;');
};

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    var clearTasksTimeout = null;
    var clearTasksAfterMs = 5 * 1000;

    $(document).on('click', '.js-admin-tasks-modal-button', function (e) {
        var $modal = $('.admin-tasks-modal');
        $modal.toggleClass("hidden");
        e.preventDefault();

        if (clearTasksTimeout) {
            clearTimeout(clearTasksTimeout);
        }

        var clearTasksUrl = $modal.data("clear-tasks-url");
        if (!$modal.hasClass("hidden") && clearTasksUrl) {
            clearTasksTimeout = setTimeout(function () {
                $.ajax({ url: clearTasksUrl, method: "POST" });
                $modal.find(".--new").removeClass("--new");
            }, clearTasksAfterMs);
        }
    });
})();

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function ($) {
    'use strict';

    function ImagePicker() {
        this.container = $('body');
        this.imagePickerUrl = window.urls.pictureList;
        this._reset();
    }

    ImagePicker.prototype.open = function (callback) {
        var self = this;
        var $modal = this.modalContainer = $(this._generateModalHTML());

        $modal.find('.modal-content').parent().load(this.imagePickerUrl);

        this.modalContainer.one('hidden.bs.modal', this._reset.bind(this));
        this.modalContainer.appendTo(this.container);
        this.modalContainer.modal({
            backdrop: false
        });
        this.modalContainer.on('picture:picked', function (event, url) {
            self.close();
            callback(url);
        });
    };

    ImagePicker.prototype.close = function () {
        if (this.modalContainer) {
            this.modalContainer.modal('hide');
        }
    };

    ImagePicker.prototype._reset = function () {
        if (this.modalContainer) {
            this.modalContainer.remove();
        }
        this.modalContainer = null;
    };

    ImagePicker.prototype._generateModalHTML = function () {
        return '\n' + '<!-- Modal -->\n' + '<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="pictures-modal-title" aria-hidden="true">\n' + '  <div class="modal-dialog modal-viewport">\n' + '    <div class="modal-content">\n' + '      <div class="modal-header">\n' + '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\n' + '        <h4 class="modal-title" id="pictures-modal-title">' + gettext("Images") + '</h4>\n' + '      </div>\n' + '      <div class="modal-body">\n' + '        ...\n' + '      </div>\n' + '    </div><!-- /.modal-content -->\n' + '  </div><!-- /.modal-dialog -->\n' + '</div><!-- /.modal -->';
    };

    $(function () {
        $.imagePicker = new ImagePicker();
    });
})(jQuery);

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function ($) {
    'use strict';

    function createFolder(opts, callback) {
        var $modal = $(generateModalHTML($.extend({
            title: gettext("Add new folder"),
            actionUrl: opts.createFolderUrl,
            submitLabel: pgettext("Folder", "Add")
        }, opts)));

        return openFolderModal($modal, callback);
    }

    function editFolder(opts, callback) {
        var $modal = $(generateModalHTML($.extend({
            title: gettext("Edit folder"),
            actionUrl: opts.updateUrl,
            submitLabel: gettext("Save")
        }, opts)));

        return openFolderModal($modal, callback);
    }

    function openFolderModal($modal, callback) {
        var $validationError = $modal.find('.validation-error');

        $modal.one('hidden.bs.modal', function () {
            $modal.remove();
        });

        $modal.find('form').ajaxForm({
            dataType: 'json',
            beforeSubmit: function beforeSubmit() {
                $modal.find('input, button').prop('disabled', true);
                $validationError.text('');
            },
            success: function success(data) {
                callback(data);
                $modal.modal('hide');
            },
            error: function error(data) {
                $modal.find('input, button').prop('disabled', false);
                if (data.responseJSON) {
                    $validationError.text($.map(data.responseJSON, function (v, k) {
                        return v;
                    }).join(", "));
                } else {
                    $validationError.text(gettext("Unknown error occured"));
                    Sentry.captureMessage('Failed to save folder with HTTP status: ' + data.status, {
                        extra: {
                            response: data
                        }
                    });
                }
            }
        });

        $modal.appendTo($('body')).modal({
            backdrop: false
        });
    }

    function generateModalHTML(opts) {
        var folderNameStr = pgettext("Folder", "Name");

        return "\n            <!-- Modal -->\n            <div class=\"modal fade\" id=\"new-folder-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"new-folder-modal-title\" aria-hidden=\"true\">\n              <div class=\"modal-dialog modal-sm\">\n                <div class=\"modal-content\">\n                  <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                    <h4 class=\"modal-title\" id=\"new-folder-modal-title\">\n                        " + opts.title + "\n                    </h4>\n                  </div>\n                    <form method=\"post\" action=\"" + opts.actionUrl + "\">\n                        <div class=\"modal-body\">\n                            <input name=\"name\" value=\"" + (opts.name || '') + "\" placeholder=\"" + folderNameStr + "\" class=\"form-control\"/>\n                            <input type=\"hidden\" name=\"parent\" value=\"" + (opts.parent || '') + "\"/>\n                            <input type=\"hidden\" name=\"context\" value=\"" + opts.context + "\"/>\n                            <div class=\"validation-error\"></div>\n                            <input type=\"hidden\" name=\"csrftoken\" value=\"" + $.cookie('weekly_csrf') + "\"/>\n                      </div>\n                      <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">" + gettext("Cancel") + "</button>\n                        <button type=\"submit\" class=\"btn btn-primary\">" + opts.submitLabel + "</button>\n                      </div>\n                    </form>\n                </div><!-- /.modal-content -->\n              </div><!-- /.modal-dialog -->\n            </div><!-- /.modal -->\n        ";
    }

    $(function () {
        $.createFolder = createFolder;
        $.editFolder = editFolder;
    });
})(jQuery);

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperties = __webpack_require__(855);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Based on https://github.com/mbertheau/jquery.django-formset
var __hasProp = {}.hasOwnProperty,
    __extends = function __extends(child, parent) {
    for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
        this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
};

/** @typedef {Object} DjangoFormsetOptions
 * @property {string=} prefix Prefiks formsetu. Domyślnie odgadywany z pustego formularza.
 * @property {string} deleteButtonText Surowy HTML przycisku "usuń"
 * @property {string} deleteButtonClass CSS Query (nie klasa!) przycisku "usuń", wyklucza się z `deleteButtonText`
 * @property {boolean=true} handleOrderInput Czy ukrywać i uzupełniać pole ORDER?
 * @property {string} formNumberContainer CSS Query wskazujące element, którego tekst przedstawia numer formularza
 * @property {DjangoFormsetHandlers} on Event handlery
 */

/** @typedef {Object} DjangoFormsetHandlers
 * @property {function (event, form)} formInitialized Wywoływany po uruchomieniu formsetu i dla każdego dodanego formularza
 */

(function ($) {
    'use strict';

    var FormsetError;
    /** @param {DjangoFormsetOptions} options */
    $.fn.djangoFormset = function (options) {
        return new $.fn.djangoFormset.Formset(this, options);
    };
    FormsetError = function (_super) {
        __extends(FormsetError, _super);

        function FormsetError() {
            return FormsetError.__super__.constructor.apply(this, arguments);
        }

        return FormsetError;
    }(Error);
    $.fn.djangoFormset.Formset = function () {
        function Formset(base, options) {
            var deletedForms, forms, inputName, placeholderPos;
            this.opts = $.extend({}, $.fn.djangoFormset.defaultOptions, options);
            if (base.length === 0) {
                throw new FormsetError("Empty selector.");
            }
            this.template = base.filter("." + this.opts.formTemplateClass);
            if (this.template.length === 0) {
                throw new FormsetError("Can't find template (looking for ." + this.opts.formTemplateClass + ")");
            }
            inputName = this.template.find("input,select,textarea").first().attr('name');
            if (!inputName) {
                throw new FormsetError("Can't figure out form prefix because there's no form input in the form template. Please add one.");
            }
            if (this.opts.prefix) {
                this.prefix = this.opts.prefix;
            } else {
                placeholderPos = inputName.indexOf('-__prefix__');
                if (placeholderPos === -1) {
                    throw new FormsetError("Can't figure out form prefix from template because it doesn't contain '-__prefix__'.");
                }
                this.prefix = inputName.substring(0, placeholderPos);
            }
            this.totalForms = $("#id_" + this.prefix + "-TOTAL_FORMS");
            this.initialFormsElem = $("#id_" + this.prefix + "-INITIAL_FORMS");
            var maxNumFormsRaw = $("#id_" + this.prefix + "-MAX_NUM_FORMS").val();
            this.maxNumForms = maxNumFormsRaw ? parseInt(maxNumFormsRaw, 10) : null;
            if (this.totalForms.length === 0) {
                throw new FormsetError("Management form field 'TOTAL_FORMS' not found for prefix " + this.prefix + ".");
            }
            forms = base.not("." + this.opts.formTemplateClass);
            this.initialForms = forms.length;
            $(this).on(this.opts.on);
            this.forms = forms.map(function (_this) {
                return function (index, element) {
                    var newForm;
                    newForm = new _this.opts.formClass($(element), _this, index);
                    $(_this).trigger("formInitialized", [newForm]);
                    return newForm;
                };
            }(this));
            if (this.forms.length !== parseInt(this.totalForms.val())) {
                console.error("TOTAL_FORMS is " + this.totalForms.val() + ", but " + this.forms.length + " non-template elements found in passed selection.");
            }
            deletedForms = this.forms.filter(function () {
                return this.deleteInput.val();
            });
            deletedForms.each(function () {
                return this["delete"]();
            });
            this.insertAnchor = base.not("." + this.opts.formTemplateClass).last();
            if (this.insertAnchor.length === 0) {
                this.insertAnchor = this.template;
            }
            return;
        }

        (0, _defineProperties2.default)(Formset.prototype, {
            visibleForms: {
                get: function getVisibleForms() {
                    return this.forms.filter(function () {
                        return this.isVisible();
                    });
                }
            },
            canAddForm: {
                get: function getCanAddForm() {
                    if (this.maxNumForms) {
                        return this.visibleForms.length < this.maxNumForms;
                    } else {
                        return true;
                    }
                }
            }
        });

        /**
         * @param {Object=} opts
         * @param {jQuery=} opts.template - pusty formularz do skopiowania, domyślnie znaleziony w formsecie
         * @param {boolean=false} opts.initial - czy ten formularz był obecny przy ładowaniu strony?
         * @return {Form}
         */
        Formset.prototype.addForm = function (opts) {
            var newForm, newFormElem;
            if (!this.canAddForm) return;
            opts = opts || {};
            if (opts.initial) {
                this.initialForms += 1;
                this.initialFormsElem.val(this.initialForms);
            }
            var template = opts.template || this.template;
            newFormElem = template.clone().removeClass(this.opts.formTemplateClass).attr("id", null);
            newForm = new this.opts.formClass(newFormElem, this, parseInt(this.totalForms.val()));
            newFormElem.insertAfter(this.insertAnchor.last());
            this.insertAnchor = newFormElem;
            this.forms.push(newForm);
            this.totalForms.val(parseInt(this.totalForms.val()) + 1);
            $(this).trigger("formInitialized", [newForm]);
            $(this).trigger("formAdded", [newForm]);
            this.updateFormsVisibleIndexes();
            newFormElem.find("input,textarea,select").first().focus();
            return newForm;
        };

        Formset.prototype.deleteForm = function (index) {
            var form;
            form = this.forms[index];
            form["delete"]();
            this.updateFormsVisibleIndexes();
        };

        Formset.prototype.handleFormRemoved = function (index) {
            var form, i, _i, _len, _ref;
            this.totalForms.val(parseInt(this.totalForms.val()) - 1);
            if (this.forms[index].isInitial()) {
                this.initialForms -= 1;
                this.initialFormsElem.val(this.initialForms);
            }
            this.forms.splice(index, 1);
            _ref = this.forms;
            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                form = _ref[i];
                form._updateFormIndex(i);
            }
            if (this.forms.length === 0) {
                this.insertAnchor = this.template;
            } else {
                this.insertAnchor = this.forms[this.forms.length - 1].elem;
            }
        };

        Formset.prototype.updateFormsVisibleIndexes = function () {
            var form,
                i,
                currentNumber = 1;
            if (this.opts.formNumberContainer === undefined) return;
            for (i = 0; i < this.forms.length; i = ++i) {
                form = this.forms[i];
                var form_elem = form.elem;
                if (form.isVisible()) {
                    form_elem.find(this.opts.formNumberContainer).text(currentNumber.toString());
                    if (this.opts.handleOrderInput) form.orderInput.val(currentNumber);
                    currentNumber++;
                }
            }
        };

        return Formset;
    }();
    $.fn.djangoFormset.Form = function () {
        function Form(elem, formset, index) {
            var isInitial;
            this.elem = elem;
            this.formset = formset;
            this.index = index;
            this.elem.data('djangoFormset.Form', this);
            if (this.index !== void 0) {
                this._initFormIndex(this.index);
            }
            this.reinit();
            if (formset.opts.handleOrderInput) this.orderInput.hide();

            if (this.deleteInput.length > 0 || !this.isInitial()) {
                this._replaceDeleteCheckboxWithButton();
            }
        }

        Form.prototype.reinit = function () {
            this.deleteInput = this.field('DELETE');
            this.orderInput = this.field('ORDER');
        };

        Form.prototype.isInitial = function () {
            return this.index < this.formset.initialForms;
        };

        Form.prototype.getDeleteButton = function () {
            if (this.formset.opts.deleteButtonClass !== undefined) {
                return this.elem.find(this.formset.opts.deleteButtonClass);
            }
            return $("<button type='button' class='btn btn-danger'> " + this.formset.opts.deleteButtonText + " </button>");
        };

        Form.prototype.insertDeleteButton = function () {
            if (this.deleteInput.length > 0) {
                this.deleteInput.after(this.deleteButton);
            } else {
                (this.elem.is('TR') ? this.elem.children().last() : this.elem.is('UL') || this.elem.is('OL') ? this.elem.append('li').children().last() : this.elem).append(this.deleteButton);
            }
        };

        Form.prototype.isVisible = function () {
            return !this.elem.hasClass('deleted');
        };

        Form.prototype["delete"] = function (opts) {
            var opts = opts || {};
            var isInitial,
                forceDestroy = !!opts.forceDestroy;
            isInitial = this.isInitial();
            if (this.deleteInput.length === 0 && isInitial) {
                console.warn("Tried do delete non-deletable form " + this.formset.prefix + " #" + this.index + ".");
                return;
            }
            if (isInitial && !forceDestroy) {
                if (this.deleteInput.length > 0) {
                    this.deleteInput.val('on');
                    this.elem.addClass('deleted');
                }
                this.hide();
            } else {
                this.elem.remove();
                this.formset.handleFormRemoved(this.index);
            }
            this.formset.updateFormsVisibleIndexes();
            $(this.formset).trigger("formDeleted", [this]);
        };

        Form.prototype.hide = function () {
            return this.elem.hide();
        };

        Form.prototype.field = function (name) {
            return this.elem.find("[name='" + this.formset.prefix + "-" + this.index + "-" + name + "']");
        };

        /**
         * @param name - nazwa pola w formularzu
         * @return {string} - nazwa pola wzbogacona o prefix formularza
         */
        Form.prototype.addPrefix = function (name) {
            return this.formset.prefix + "-" + this.index + "-" + name;
        };

        Form.prototype.prev = function () {
            var form, _i, _ref;
            _ref = this.formset.forms.slice(0, +(this.index - 1) + 1 || 9e9);
            for (_i = _ref.length - 1; _i >= 0; _i += -1) {
                form = _ref[_i];
                if (form.elem.is(':visible')) {
                    return form;
                }
            }
        };

        Form.prototype._replaceDeleteCheckboxWithButton = function () {
            var label, newDeleteInput;
            if (this.deleteInput.length > 0) {
                newDeleteInput = $("<input type='hidden' name='" + this.deleteInput.attr('name') + "' id='" + this.deleteInput.attr('id') + "' value='" + (this.deleteInput.is(':checked') ? 'on' : '') + "'/>");
                label = this.elem.find("label[for='" + this.deleteInput.attr('id') + "']");
                if (label.has(this.deleteInput).length > 0) {
                    label.replaceWith(newDeleteInput);
                } else {
                    label.remove();
                    this.deleteInput.replaceWith(newDeleteInput);
                }
                this.deleteInput = newDeleteInput;
            }
            this.deleteButton = this.getDeleteButton();
            this.deleteButton.on('click', this.formset.opts.onDeleteConstructor(this));
            if (this.formset.opts.deleteButtonClass === undefined) {
                this.insertDeleteButton();
            }
        };

        Form.prototype._replaceFormIndex = function (oldIndexPattern, index) {
            var newPrefix, prefixRegex, _replaceFormIndexElement;
            this.index = index;
            prefixRegex = new RegExp("" + this.formset.prefix + "-" + oldIndexPattern);
            newPrefix = "" + this.formset.prefix + "-" + index;
            _replaceFormIndexElement = function _replaceFormIndexElement(elem) {
                var attributeName, attributeNames, attributeNamesByTagName, tagName, _i, _len, _results;
                attributeNamesByTagName = {
                    input: ['id', 'name'],
                    select: ['id', 'name'],
                    textarea: ['id', 'name'],
                    label: ['for'],
                    div: ['id'],
                    '*': ['href', 'data-target']
                };
                tagName = elem.get(0).tagName;
                attributeNames = [];
                if (tagName.toLowerCase() in attributeNamesByTagName) {
                    attributeNames = attributeNamesByTagName[tagName.toLowerCase()];
                }
                attributeNames.push.apply(attributeNames, attributeNamesByTagName['*']);
                _results = [];
                for (_i = 0, _len = attributeNames.length; _i < _len; _i++) {
                    attributeName = attributeNames[_i];
                    if (elem.attr(attributeName)) {
                        _results.push(elem.attr(attributeName, elem.attr(attributeName).replace(prefixRegex, newPrefix)));
                    } else {
                        _results.push(void 0);
                    }
                }
                return _results;
            };
            _replaceFormIndexElement(this.elem);
            this.elem.find('input, select, textarea, label, div').each(function () {
                _replaceFormIndexElement($(this));
            });
        };

        Form.prototype._initFormIndex = function (index) {
            this._replaceFormIndex("__prefix__", index);
        };

        Form.prototype._updateFormIndex = function (index) {
            this._replaceFormIndex('\\d+', index);
        };

        return Form;
    }();
    $.fn.djangoFormset.defaultOptions = {
        formTemplateClass: 'empty-form',
        formClass: $.fn.djangoFormset.Form,
        deleteButtonText: 'Delete',
        deleteButtonClass: undefined,
        onDeleteConstructor: function onDeleteConstructor(_this) {
            return function (event) {
                return _this["delete"]();
            };
        },
        formNumberContainer: undefined,
        handleOrderInput: true
    };
    $.djangoFormset = {};
})(jQuery);

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*global showConfirmationBox */
$(function () {
    'use strict';

    $('.set-status-link').each(function () {
        var href = $(this).data('href'),
            checkbox = $(this),
            button,
            is_checked = checkbox.prop('checked');
        if (checkbox.data('true') && checkbox.data('false')) {
            checkbox.hide();
            button = $('<span class="set-status-button">');
            button.text(checkbox.data(is_checked.toString()));
            checkbox.before(button);
            button.on('click', function () {
                var is_checked,
                    data_submit = function data_submit(is_checked) {
                    checkbox.prop('checked', !is_checked).change();
                    button.text(checkbox.data((!is_checked).toString()));
                };
                is_checked = checkbox.prop('checked');
                if (is_checked && checkbox.data('uncheck-confirm')) {
                    showConfirmationBox({
                        text: checkbox.data('uncheck-confirm'),
                        buttons: [{
                            text: 'potwierd\u017A',
                            click: function click() {
                                $('#confirmation_box').remove();
                                data_submit(is_checked);
                            }
                        }, 'cancel']
                    });
                } else {
                    data_submit(is_checked);
                }
            });
        }
        checkbox.on('change', function () {
            var is_checked = $(this).prop('checked');
            $.post(href, { 'value': is_checked });
        });
    });
});

/***/ })

},[849]);


// WEBPACK FOOTER //
// base-d9eed0963f255d9cb937.js